import { Component, Input } from '@angular/core';
import { SharedModule } from 'src/app/_shared/_shared.module';

@Component({
  selector: 'app-tag-estado-ronda',
  templateUrl: './tag-estado-ronda.component.html',
  styleUrls: ['./tag-estado-ronda.component.scss'],
  standalone: true,
  imports:[
    SharedModule
  ]
})

// [OBSOLETE]: Componente obsoleto, eliminar con el restyling (se utiliza todavía) y utilizar solo el tag-estado-ronda-realestate 
export class TagEstadoRondaComponent {
  @Input() tipoEstadoRonda: string;
}
